import { Clientes } from './cliente';
import { Compradetalle } from './compradetalle';


export class Compras {
    id:number;
    idEmisor:number;
    fecha:string;
    idCliente:number;
    valorTotal:number;
    valorIva:number;
    valorSubTotal:number;
    tipoDoc:string;
    tipoCompra:string;
    factura:string;
    serie:string;
    det:  Compradetalle[]= [];
    estado:string;
    fechaP:string;
    vendedor:string;
    tipoDocMovi:string;
    observacion:string;
    numeroAutorizacion:string;
    enviado:string;
    subTotal:number;
    xml:string;
    cliente:Clientes;
    }
    